import React, { Component } from 'react';
import { translate, ViewTitle, Restricted } from 'admin-on-rest';

import {
  Card,
  CardText,
  FloatingActionButton,
  MenuItem,
  IconMenu,
  Dialog,
  FlatButton,
  Toolbar,
  ToolbarGroup,
  RaisedButton,
  List,
  ListItem,
  IconButton,
  Divider,
  Subheader,
  Checkbox,
  CircularProgress,
} from 'material-ui';

import Add from 'material-ui/svg-icons/content/add';
import Sort from 'material-ui/svg-icons/content/sort';
import Save from 'material-ui/svg-icons/content/save';
import ArrowRight from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import DragHandleIcon from 'material-ui/svg-icons/editor/drag-handle';
import Promo from 'material-ui/svg-icons/social/whatshot';
import Remove from 'material-ui/svg-icons/navigation/close';

import { keys, set } from 'lodash';
import plz from 'await-plz';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove,
} from 'react-sortable-hoc';
import queryString from 'query-string';

import './style.css';
import { getTranslationByLocale } from '../../utils/TranslationUtils';

import blockComponents, { lookupTable } from '../blocks';
import blockFields from '../blocks/fields';

const styles = {
  mobileToolbar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'rgb(183, 28, 28)',
    justifyContent: 'flex-end',
    zIndex: 2,
  },
};

const DragHandle = SortableHandle(() => (
  <span className="list-handle">
    <DragHandleIcon />
  </span>
));

const SortableItem = SortableElement(({ value }) => (
  <Card className="block">
    <DragHandle />
    {value}
  </Card>
));

const SortableBlockList = SortableContainer(({ blocks, locale }) => (
  <div className="blocks sorting">
    {blocks.map((block, index) => {
      const title = lookupTable[block.type]
        ? lookupTable[block.type].title
        : block.type;
      const Icon = lookupTable[block.type]
        ? lookupTable[block.type].icon
        : null;

      return (
        <SortableItem
          index={index}
          value={
            <CardText>
              <span className="block-type">
                <div>
                  {Icon ? <Icon /> : null}
                  <span className="title">{title}</span>
                </div>
              </span>
              <div className="content">
                {React.createElement(blockFields[block.type], {
                  block,
                  locale,
                })}
              </div>
            </CardText>
          }
        />
      );
    })}
  </div>
));

const FixedToolBar = (
  { onSave, changes, translate } // eslint-disable-line
) => (
  <Toolbar style={styles.mobileToolbar}>
    <ToolbarGroup>
      <span className="changes-span">
        {changes > 0 && `${changes} ändrade block`}
      </span>
      <RaisedButton
        className="save-button"
        label={translate('save')}
        onClick={onSave}
        icon={<Save />}
      />
    </ToolbarGroup>
  </Toolbar>
);

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';

const blockTypes = keys(blockComponents);

class PageBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      openDialog: {},
      page: {
        blocks: [],
        promos: [],
        website: {},
      },
      modifiedBlocks: {},
      loadingPromos: true,
      selectedPromo: {},
    };
  }

  componentWillMount = async () => {
    this.getPage();
  };

  componentWillUpdate = async (nextProps, nextState) => {
    if (
      !this.state.openDialog.action &&
      nextState.openDialog.action === 'promo'
    ) {
      const params = {
        range: '[0,9999]',
        filter: JSON.stringify({
          _id: { $nin: nextState.page.promos.map((p) => p._id) },
        }),
      };

      const [err, promos] = await plz(
        fetch(`${API_BASE_URL}/web-promos?${queryString.stringify(params)}`, {
          credentials: 'include',
        })
      );
      if (err) return console.error('Failed fetching page', err);
      if (!promos) return console.error('No page found');

      return this.setState({ promos, loadingPromos: false });
    }
    return null;
  };

  getPage = async () => {
    const [err, page] = await plz(
      fetch(`${API_BASE_URL}/web-pages/${this.props.match.params.id}`, {
        credentials: 'include',
      })
    );
    if (err) return console.error('Failed fetching page', err);
    if (!page) return console.error('No page found');
    return this.setState({ page });
  };

  savePage = async () => {
    const { page: statePage } = this.state;

    const [err, page] = await plz(
      fetch(`${API_BASE_URL}/web-pages/${this.props.match.params.id}`, {
        method: 'PUT',
        headers: {
          'content-type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ ...statePage }),
      })
    );
    if (err) return console.error('Failed updating page', err);
    if (!page) return console.error("Could'nt find page");

    return this.setState({ page }, this.toggleSorting);
  };

  sort = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const { page } = this.state;
      const { blocks } = page;
      const reorderedBlocks = arrayMove(blocks, oldIndex, newIndex);

      this.setState({ page: set(page, 'blocks', reorderedBlocks) });
    }
  };

  addBlock = async () => {
    const { page: statePage, formData } = this.state;
    this.setState({ addingBlock: true });
    const [err, block] = await plz(
      fetch(`${API_BASE_URL}/web-blocks`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(formData),
      })
    );
    if (err) return console.error('Failed creating block', err);
    if (!block) return console.error('No block found');

    const [error, page] = await plz(
      fetch(`${API_BASE_URL}/web-pages/${this.props.match.params.id}`, {
        method: 'PUT',
        headers: {
          'content-type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          ...statePage,
          blocks: [...statePage.blocks, block],
        }),
      })
    );
    if (error) return console.error('Failed updating page', error);
    if (!page) return console.error("Could'nt find page");

    return this.setState(() => ({
      page,
      openDialog: {},
      formData: {},
      addingBlock: false,
    }));
  };

  deleteBlock = async (id) => {
    const { page: statePage } = this.state;
    const [err, block] = await plz(
      fetch(`${API_BASE_URL}/web-blocks/${id}`, {
        method: 'DELETE',
        headers: {
          'content-type': 'application/json',
        },
        credentials: 'include',
      })
    );
    if (err) return console.error('Failed deleting block', err);
    if (!block) return console.error('No block found at id', id);

    const [error, page] = await plz(
      fetch(`${API_BASE_URL}/web-pages/${this.props.match.params.id}`, {
        method: 'PUT',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          ...statePage,
          blocks: statePage.blocks.filter((b) => b._id !== id),
        }),
        credentials: 'include',
      })
    );
    if (error) return console.error('Failed updating page', error);
    if (!page) return console.error("Could'nt find page");

    return this.setState(() => ({ page, openDialog: {} }));
  };

  addPromo = async () => {
    const { page: statePage, selectedPromo } = this.state;

    const [error, page] = await plz(
      fetch(`${API_BASE_URL}/web-pages/${this.props.match.params.id}`, {
        method: 'PUT',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          ...statePage,
          promos: [...statePage.promos, selectedPromo],
        }),
        credentials: 'include',
      })
    );
    if (error) return console.error('Failed updating page', error);
    if (!page) return console.error("Could'nt find page");

    return this.setState(() => ({ page, openDialog: {}, selectedPromo: {} }));
  };

  deletePromo = async (id) => {
    const { page: statePage } = this.state;

    const [error, page] = await plz(
      fetch(`${API_BASE_URL}/web-pages/${this.props.match.params.id}`, {
        method: 'PUT',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          ...statePage,
          promos: statePage.promos.filter((p) => p._id !== id),
        }),
        credentials: 'include',
      })
    );
    if (error) return console.error('Failed updating page', error);
    if (!page) return console.error("Could'nt find page");

    return this.setState(() => ({ page, openDialog: {} }));
  };

  updateBlock = async () => {
    const blocks = this.state.modifiedBlocks;

    const queries = await Object.keys(blocks).map(async (key) => {
      const [err, block] = await plz(
        fetch(`${API_BASE_URL}/web-blocks/${key}`, {
          method: 'PUT',
          headers: {
            'content-type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify(blocks[key]),
        })
      );
      if (err) return console.error('Failed updating block', err);
      if (!block) return console.error('No block found at id', key);
      return block;
    });

    try {
      await Promise.all(queries);
    } catch (e) {
      console.log('a promise failed when updating blocks', e);
    }
    this.setState({ modifiedBlocks: {} });
    this.getPage();
  };

  change = (name, id, value) => {
    if (!id) {
      this.setState((state) => ({
        formData: set(state.formData, name, value),
      }));
    }
    if (id) {
      const block = this.state.page.blocks.find((b) => b._id === id);

      let { modifiedBlocks } = this.state;
      if (!this.state.modifiedBlocks[id]) {
        modifiedBlocks = set(this.state.modifiedBlocks, id, block);
      }

      this.setState(() => ({
        modifiedBlocks: set(modifiedBlocks, `${id}.${name}`, value),
      }));
    }
  };

  selectPromo = (selectedPromo) => this.setState({ selectedPromo });

  resetSorting = () =>
    this.setState((state) => ({
      sorting: false,
      page: set(state.page, 'blocks', state.originalOrder),
    }));

  toggleDialog = (action, data) =>
    this.setState((state) => ({
      openDialog: data ? { action, data } : {},
      formData: set(state.formData, 'type', data),
      selectedPromo: {},
    }));

  toggleSorting = () =>
    this.setState((state) => ({
      sorting: !state.sorting,
      originalOrder: !state.sorting ? state.page.blocks : [],
    }));

  render() {
    const { location, translate: t, locale } = this.props;
    const {
      openDialog,
      page,
      modifiedBlocks,
      sorting,
      promos,
      loadingPromos,
      selectedPromo,
      formData: { type },
      addingBlock,
    } = this.state;
    const { blocks } = page;

    return (
      <Restricted
        authParams={{ route: '/page-builder/:id' }}
        location={location}
      >
        <div className="page-builder">
          <Card>
            <ViewTitle
              title={
                <span className="header">
                  <span className="breadcrumb">
                    <span className="website-name">{page.website.name}</span>
                    <ArrowRight />
                    <span className="slug">page/{page.slug}</span>
                  </span>
                  <span className="sorting-controls">
                    {sorting ? (
                      <div>
                        <FlatButton
                          className="cancel"
                          label="Cancel"
                          onClick={this.resetSorting}
                        />
                        <RaisedButton
                          className="cancel"
                          primary
                          label="Save"
                          onClick={this.savePage}
                        />
                      </div>
                    ) : (
                      <div>
                        <FloatingActionButton
                          mini
                          children={<Promo />}
                          onClick={() => this.toggleDialog('promo', {})}
                        />
                        &nbsp;
                        <FloatingActionButton
                          primary
                          mini
                          children={<Sort />}
                          onClick={this.toggleSorting}
                        />
                      </div>
                    )}
                  </span>
                </span>
              }
            />
            <CardText>
              {sorting ? (
                <SortableBlockList
                  onSortEnd={this.sort}
                  blocks={blocks}
                  {...this.props}
                />
              ) : (
                <div>
                  <div className="promos">
                    <Card className="promo-list">
                      <List className="list">
                        <Subheader children="Promos" />
                        <Divider />
                        {page.promos.length === 0 && (
                          <h4 style={{ width: '100%', textAlign: 'center' }}>
                            No promos yet, add via <Promo />
                          </h4>
                        )}
                        {page.promos.map((promo) => (
                          <ListItem
                            disabled
                            className="promo-item"
                            primaryText={getTranslationByLocale(
                              promo.headingBold,
                              locale
                            )}
                            secondaryText={getTranslationByLocale(
                              promo.headingThin,
                              locale
                            )}
                            rightIconButton={
                              <IconButton
                                children={<Remove />}
                                onClick={() => this.deletePromo(promo._id)}
                              />
                            }
                          />
                        ))}
                      </List>
                    </Card>
                  </div>
                </div>
              )}
            </CardText>
            {!sorting && (
              <Card className="blocks">
                <Subheader children={t('website.blocks.name')} />
                <Divider />
                {blocks.map((block) => {
                  // const title = lookupTable[block.type] ? lookupTable[block.type].title : block.type;
                  const Icon = lookupTable[block.type]
                    ? lookupTable[block.type].icon
                    : null;
                  return (
                    <Card className="block-item">
                      <span className="block-type">
                        <span className="title">
                          {Icon ? <Icon /> : null}
                          <span className="title">
                            {t(`website.blocks.${block.type}`)}
                          </span>
                        </span>
                        <IconButton
                          mini
                          children={<Remove />}
                          onClick={() => this.deleteBlock(block._id)}
                        />
                      </span>

                      <div className="content">
                        {React.createElement(blockComponents[block.type], {
                          onChange: this.change,
                          id: block._id,
                          values: block,
                        })}
                      </div>
                    </Card>
                  );
                })}
                <div className="add-block">
                  <IconMenu
                    iconButtonElement={
                      <FloatingActionButton mini children={<Add />} />
                    }
                    anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                    onChange={(e, child) => this.toggleDialog('add', child)}
                    maxHeight={272}
                  >
                    {blockTypes.map((blockType) => {
                      // const title = lookupTable[blockType] ? lookupTable[blockType].title : blockType;
                      const Icon = lookupTable[blockType]
                        ? lookupTable[blockType].icon
                        : null;
                      return (
                        <MenuItem
                          value={blockType}
                          primaryText={t(`website.blocks.${blockType}`)}
                          leftIcon={Icon ? <Icon /> : null}
                        />
                      );
                    })}
                  </IconMenu>
                </div>
              </Card>
            )}
          </Card>
          <Dialog
            open={openDialog.action === 'add'}
            onRequestClose={this.toggleDialog}
            actions={[
              <FlatButton label={t('cancel')} onClick={this.toggleDialog} />,
              <FlatButton
                primary
                label={t('add')}
                disabled={addingBlock}
                onClick={this.addBlock}
              />,
            ]}
            title={`Add ${t(`website.blocks.${type}`)} block`}
            className="add-block-dialog"
            contentStyle={{ maxWidth: '1040px', width: '90%' }}
            bodyStyle={{ width: '100%', overflow: 'auto' }}
          >
            {React.createElement(blockComponents[openDialog.data], {
              onChange: this.change,
            })}
            {addingBlock ? (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <CircularProgress />
              </div>
            ) : null}
          </Dialog>

          {Object.keys(modifiedBlocks).length > 0 && (
            <FixedToolBar
              changes={Object.keys(modifiedBlocks).length}
              onSave={this.updateBlock}
              translate={t}
            />
          )}

          <Dialog
            open={openDialog.action === 'promo'}
            onRequestClose={this.toggleDialog}
            actions={[
              <FlatButton label={t('cancel')} onClick={this.toggleDialog} />,
              <FlatButton primary label={t('add')} onClick={this.addPromo} />,
            ]}
            title="Add promo"
            contentStyle={{ maxWidth: '1040px', width: '90%' }}
            bodyStyle={{ width: '100%', overflow: 'auto' }}
          >
            {loadingPromos ? (
              <CircularProgress />
            ) : (
              <Card className="promo-list">
                {promos.length === 0 && (
                  <h4 style={{ width: '100%', textAlign: 'center' }}>
                    No promos left!
                  </h4>
                )}
                <List className="list">
                  {promos.map((promo) => (
                    <ListItem
                      className="promo-item"
                      leftCheckbox={
                        <Checkbox
                          checked={promo._id === selectedPromo._id}
                          onClick={() => this.selectPromo(promo)}
                        />
                      }
                      primaryText={
                        promo.internalName ||
                        getTranslationByLocale(promo.headingBold, locale)
                      }
                      secondaryText={
                        promo.internalName
                          ? getTranslationByLocale(promo.headingBold, locale)
                          : getTranslationByLocale(promo.headingThin, locale)
                      }
                    />
                  ))}
                </List>
              </Card>
            )}
          </Dialog>
        </div>
      </Restricted>
    );
  }
}

export default translate(PageBuilder);
